<script>
    import { Router, Route } from "svelte-routing";
    import Chapter from "../components/Chapter/Chapter.svelte";
    import Books from "../components/Books/Books.svelte";
    import Login from "../pages/Login.svelte";
</script>

<Router>
    <Route path="/" component={Login} />
    <Route path="books" component={Books} />
    <Route path="/books/:id" component={Chapter} />
</Router>
